import React from 'react';
import { useSelector } from 'react-redux';
import InformeCrediticio from './InformeBienestar';

export const PageAdmin = () => {
  const { informeAImprimir } = useSelector((state) => state.contadorInfor);
  return <InformeCrediticio informeAImprimir={informeAImprimir} />;
};
